import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    Box,
    CssBaseline,
} from '@mui/material';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../Components/ErrorBoundary';
import RightDrawer from '../Components/RightDrawer';
import { SeasonShowContext } from '../Providers/SeasonShowProvider';
import { useLazyQuery } from '@apollo/client';
import { graphql } from 'gql';
import AppBar from './AppBar';
import DrawerHeader from './DrawerHeader';
import Main from './Main';
import { SortDirection } from 'gql/graphql';
import Drawer from './Drawer';

const drawerWidth = 280;

const GetEpisodesForSeason = graphql(`
    query GetEpisodesForSeason_Layout($where: EpisodeWhere,  $options: EpisodeOptions) {
        ...AppBarEpisodeData
        ...DrawerEpisodeData
    }`);

export default function Index() {
    const { selectedSeason } = useContext(SeasonShowContext);
    const lastSelectedSeason = useRef<string>();

    const [getEpisodes, { data: episodesData }] = useLazyQuery(GetEpisodesForSeason)
    useEffect(() => {
        // Don't call this needlessly, but allow it to be called to clear data when it needs to
        if (!selectedSeason && !lastSelectedSeason.current) return;

        getEpisodes({
            variables: {
                where: {
                    season: {
                        id: selectedSeason?.id ?? '',
                    },
                },
                options: { sort: [{ created: SortDirection.Asc }]},
            }});

        lastSelectedSeason.current = selectedSeason?.id ?? '';
    }, [getEpisodes, selectedSeason])

    const [open, setOpen] = useState(true);

    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar open={open} drawerWidth={drawerWidth} data={episodesData} handleDrawerOpen={handleDrawerOpen} />
            <Drawer open={open} drawerWidth={drawerWidth} data={episodesData} handleDrawerClose={handleDrawerClose} />
            <Main open={open} drawerWidth={drawerWidth}>
                <DrawerHeader />
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
            </Main>
            <RightDrawer />
        </Box>
    );
}